import Phaser from 'phaser';
import './style.css';
import { createGameConfig } from '@core/config/gameConfig';
import { PLAYER_PROFILE_REGISTRY_KEY, AUDIO_REGISTRY_KEY } from '@core/scenes/BaseScene';
import { PlayerProfile } from '@core/state/PlayerProfile';
import { SaveService } from '@core/services/SaveService';
import { AudioService } from '@core/services/AudioService';
import { registerMinigames } from '@modules/index';

const GAME_PARENT_ID = 'game-root';

/** Arranque de la aplicacion: registra minijuegos, crea el juego e inyecta el perfil. */
function bootstrap(): void {
  registerMinigames();

  const game = new Phaser.Game(createGameConfig(GAME_PARENT_ID));

  const playerProfile = new PlayerProfile(new SaveService());
  game.registry.set(PLAYER_PROFILE_REGISTRY_KEY, playerProfile);
  game.registry.set(AUDIO_REGISTRY_KEY, new AudioService());

  // Solo en desarrollo: exponer el juego para depurar desde la consola del navegador
  // (por ejemplo, game.scene.start('AdventureScene')). No se incluye en produccion.
  if (import.meta.env.DEV) {
    (window as unknown as { game?: Phaser.Game }).game = game;
  }
}

bootstrap();
